import script from "./Vaults.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vaults.vue?vue&type=script&setup=true&lang=ts"

import "./Vaults.vue?vue&type=style&index=0&id=3ed5de4f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed5de4f"]])

export default __exports__